module.exports = __webpack_public_path__ + "assets/6f92d85823ab72e028e324ab1c0af67f.png";